/**
 * Core type definitions for the chess engine
 */

/**
 * Represents a square on the chess board (0-63)
 * 0 = a1, 7 = h1, 56 = a8, 63 = h8
 */
export type Square = number;

/**
 * Represents a chess piece type
 */
export enum PieceType {
  Pawn = 0,
  Knight = 1,
  Bishop = 2,
  Rook = 3,
  Queen = 4,
  King = 5,
}

/**
 * Represents a player color
 */
export enum Color {
  White = 0,
  Black = 1,
}

/**
 * Represents a piece on the board
 */
export interface Piece {
  type: PieceType;
  color: Color;
}

/**
 * Represents a chess move
 */
export interface Move {
  from: Square;
  to: Square;
  piece: Piece;
  captured?: Piece;
  promotion?: PieceType;
  isEnPassant?: boolean;
  isCastling?: boolean;
}

/**
 * Castling rights for both players
 */
export interface CastlingRights {
  whiteKingside: boolean;
  whiteQueenside: boolean;
  blackKingside: boolean;
  blackQueenside: boolean;
}

/**
 * Complete game state
 */
export interface GameState {
  board: (Piece | null)[];
  activeColor: Color;
  castlingRights: CastlingRights;
  enPassantSquare: Square | null;
  halfmoveClock: number;
  fullmoveNumber: number;
  positionHistory: string[]; // For detecting three-fold repetition
}
